import React, { useState } from 'react';
import { Calendar, ChevronDown } from 'lucide-react';

/**
 * Time period filter component
 * @param {Object} props - Component props
 * @param {Function} props.onChange - Function called when period changes
 */
const TimeFilter = ({ onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedPeriod, setSelectedPeriod] = useState('30d');

  const periods = [
    { value: '7d', label: 'Last 7 days' },
    { value: '30d', label: 'Last 30 days' },
    { value: '90d', label: 'Last 90 days' },
    { value: 'year', label: 'This year' },
    { value: 'custom', label: 'Custom range' },
  ];

  const handleSelect = (period) => {
    setSelectedPeriod(period);
    onChange(period);
    setIsOpen(false);
  };

  return (
    <div className="relative">
      <button
        type="button"
        className="flex items-center rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-secondary hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary"
        onClick={() => setIsOpen(!isOpen)}
      >
        <Calendar size={16} className="mr-2" />
        <span>{periods.find((p) => p.value === selectedPeriod)?.label || 'Select period'}</span>
        <ChevronDown size={16} className="ml-2" />
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-56 rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5 z-10">
          <div className="py-1">
            {periods.map((period) => (
              <button
                key={period.value}
                type="button"
                className={`block w-full px-4 py-2 text-left text-sm ${
                  selectedPeriod === period.value
                    ? 'bg-primary-light text-primary'
                    : 'text-secondary hover:bg-gray-50'
                }`}
                onClick={() => handleSelect(period.value)}
              >
                {period.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default TimeFilter;
